export default "__VITE_ASSET__de1a2524__"